import { useEffect } from "react";

export function usePageSEO(title, description) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} | My Biz Consulting` : "My Biz Consulting | Management Consulting & AI-Powered Business Solutions";
    
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      const prevDesc = meta?.getAttribute("content");
      if (meta) meta.setAttribute("content", description);
      return () => {
        document.title = prev;
        if (meta && prevDesc) meta.setAttribute("content", prevDesc);
      };
    }
    return () => { document.title = prev; };
  }, [title, description]);
}
